import * as React from "react";

import { cn } from "utils";

/*
  Non-stock deltas (see docs/frontend-conventions.md): brand inputs are solid
  white with a neutral `secondary-300` border, `rounded-xl`, and a light
  `secondary-200` placeholder. Stock ships `bg-transparent` (which picks up the
  page gradient and looks tinted), a blue-gray `border-input`, `rounded-md`, and
  a dark `text-muted-foreground` placeholder. Keeping the radius on the base (not
  an unlayered `[data-slot=input]` rule) lets callers override it (e.g. the home
  search `rounded-2xl`). Height is the brand `h-10` (not the stock `h-9`) so
  composed controls like the SearchBar (input + select) stay aligned — the
  SelectTrigger carries the matching `h-10` delta. Focus is the brand's quiet
  `shadow-outline-secondary`, not stock's blue `ring` (the ring belongs on
  buttons/tabs, not text inputs); `aria-invalid:border-destructive` still marks
  errors. Re-apply on `shadcn diff`.
*/
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-10 w-full min-w-0 rounded-xl border border-secondary-300 bg-background px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-secondary-200 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30",
        "focus:shadow-outline-secondary focus-visible:outline-hidden",
        "aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
